module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Love Poems from the Heart")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#love-poems-from-the-heart"
    }
  }, [_vm._v("Love Poems from the Heart")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#acknowledgment"
    }
  }, [_vm._v("Acknowledgment")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#soliloquy-of-love"
    }
  }, [_vm._v("Soliloquy of Love")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#the-being-of-me"
    }
  }, [_vm._v("The Being of Me")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#section-one-love-poems-from-the-heart"
    }
  }, [_vm._v("Section One Love Poems from the Heart")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#a-marriage-made-in-heaven"
    }
  }, [_vm._v("A Marriage Made in Heaven")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch010#lifes-dreams"
    }
  }, [_vm._v("Life’s Dreams")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#enchanting-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Enchanting Love")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#when-we-were-young",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When We Were Young")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#all-i-see-is-you",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("All I See Is You")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#many-years-ago",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Many Years Ago")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#illusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Illusion")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#the-hurt-never-stops",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hurt Never Stops")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#old-mans-lament",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Old Man’s Lament")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#loves-eternal",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Love’s Eternal")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#final-goodbye",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Final Goodbye")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#dream",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dream")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#together-again",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Together Again")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#a-little-bit-of-heaven",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Little Bit of Heaven")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#cant-let-go",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Can’t Let Go")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#prisoner",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Prisoner")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#the-feeling-of-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Feeling of Love")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#hard-to-explain",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hard to Explain")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#irish-rose",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Irish Rose")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#midnight-summers-dream",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Midnight Summer’s Dream")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#when-is-enough-enough",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When Is Enough Enough")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#till-death-do-us-part",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Till Death Do Us Part")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#mona-lisa-smile",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mona Lisa Smile")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#wait-for-me",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wait for Me")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#section-two-memoirs-in-my-mind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Section Two Memoirs in My Mind")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#coronavirus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coronavirus")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#the-sickness-continues",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sickness Continues")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#teachers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Teachers")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#a-time-to-live-and-a-time-to-die",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Time to Live and a Time to Die")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#a-house-is-not-a-home",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A House Is Not a Home")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#marie",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marie")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#nifty-fifties",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nifty Fifties")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch041#the-journey",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Journey")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#from-the-womb-to-the-tomb",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From the Womb to the Tomb")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch043#the-definition-of-a-mother",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Definition of a Mother")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch044#there-are-so-many-ways-to-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("There Are So Many Ways to Love")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch045#a-letter-for-mom",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Letter for Mom")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch046#nicolas-the-titanium-man",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nicolas; the Titanium Man")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch047#make-believe",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Make Believe")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch048#matthewrenaissance-man",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Matthew—Renaissance Man")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#the-feeling-of-love-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Feeling of Love")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch050#my-daughters-the-sisters",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Daughter’s, the Sisters")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch051#crisis",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crisis")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch052#the-sickness-continues-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Sickness Continues")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch053#i-remember",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Remember")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch054#i-remember-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I Remember")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch055#intangible-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Intangible Love")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch056#left-on-the-street-corner-alone",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Left on the Street Corner Alone")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch057#empty-house",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Empty House")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch058#nine-eleven",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nine Eleven")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch059#baby-girl",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baby Girl")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch060#wedding-day",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wedding Day")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch061#colors-of-the-rainbow",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Colors of the Rainbow")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch062#violet-the-color-she-loved",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Violet, the Color She Loved")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch063#golden-years",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Golden Years")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch064#old-feelings",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Old Feelings")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch065#peanut-butter-and-jelly",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peanut Butter and Jelly")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch066#man-of-the-year",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Man of the Year")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch067#escape",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Escape")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch068#remembering-will-have-to-do",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Remembering Will Have to Do")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch069#heart-full-of-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heart Full of Love")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch070#my-heart-is-a-lonely-place",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Heart Is a Lonely Place")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch071#where-are-you",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Where Are You?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch072#as-time-goes-by",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("As Time Goes By")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0